import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import moment from "moment";
// import { DatePicker } from 'antd';

import {Badge, Button, Modal, FormControl} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputSampleForm from "./InputSampleForm";

import styles from './SampleDataPage.module.css';
import Select from "react-select";
import {Field, FieldArray} from "formik";
import InputSampleDeletionModal from "./InputSampleDeletionModal";
import * as apiWarehouse from '../../apis/warehouses';

const InputSampleSection = (props) => {
    const defaultModal = {show: false, index: null};
    const minDate = new moment(Date()).add(3, 'hours').format('YYYY-MM-DDThh:mm');

    const params = useParams();
    const [deletionModal, setDeletionModal] = useState(defaultModal);
    const [warehouses, setWarehouses] = useState([]);

    const {values, setFieldValue, setTouched, setFieldTouched, errors, touched} = props;

    useEffect(() => {
        const fetchData = async () => {
            const whPromise = apiWarehouse.getWarehouses({sort: 'name,asc'});
            const [ whResponse ] = await Promise.all([ whPromise ]);
            setWarehouses(whResponse.data.data);
        }
        fetchData().catch(console.error);
    }, []);

    const removeSample = (index) => {
        let samples = values.sampleItems;
        samples.splice(index, 1);
        setFieldValue('sampleItems', samples);
        hideDeletionModal();
    }

    const createSample = () => {
        const sample = {itemName: '', quantity: 0, unit: ''};
        let samples = values.sampleItems;
        samples.push(sample);
        setFieldValue('sampleItems', samples);
    }

    const showDeletionModal = (index) => {
        setDeletionModal({show: true, index});
    }

    const hideDeletionModal = () => {
        setDeletionModal(defaultModal);
    }

    const getWarehouseMapping = () => {
        const mappedWarehouses = warehouses
            .filter(wh => wh.isSampleReceiver)
            .map(wh => ({ value: wh.id, label: wh.name }))
        return mappedWarehouses;
    }
    
    const handleSelectWarehouse = async (e) => {
        await setFieldTouched('warehouseId', true);

        if (e === null) {
            await setFieldValue('warehouseId', null);
            setFieldValue('warehouseName', null);
            setFieldValue('warehouseAddress', null);
            return;
        }
        const warehouse = warehouses.find(wh => wh.id == e.value)
        await setFieldValue('warehouseId', e.value);
        setFieldValue('warehouseName', warehouse.name);
        setFieldValue('warehouseAddress', warehouse.address);
    }
    
    const isErrorsEmpty = () => {
        console.log(Object.keys(errors).length);
        if (Object.keys(errors).length > 0) {
            return false;
        } else {
            return true;
        }
    }
    
    const isDisabledNextButton = () => {
        const filledSamples = values.sampleItems.filter(sample => sample.itemName && sample.quantity && sample.unit);
        if (!isErrorsEmpty() || filledSamples.length < 1 || !values.deliveryTime || !values.warehouseId)
            return true;
        else
            return false;
    }

    const handleSelectDeliveryTime = async (val) => {
        await setFieldValue('deliveryTime', val);
        await setFieldTouched('deliveryTime', true);
    }
    
    return <>
        <Badge className={styles.codeBadge}>
            Kode Registrasi : {params.code}
        </Badge>
        <div className={`${styles.sectionCard} mt-3`}>
            <div>
                <h5>Detail Pengiriman Sampel</h5>
                <p>
                    Pastikan pilih tanggal & warehouse tujuan sesuai yang Anda inginkan. Jika data sudah tersimpan, maka
                    data tidak dapat diubah kembali.
                </p>
            </div>
            <div>
                <Field name="deliveryTime">
                    {({field, form: { setFieldValue }}) => {
                        return (
                            <DatePicker
                                {...field}
                                autoComplete="off"
                                selected={field.value || null}
                                onChange={(val) => handleSelectDeliveryTime(val)}
                                className={'form-control'} placeholderText='Pilih tanggal'
                                showTimeSelect timeFormat='HH:mm' dateFormat='dd-MM-yyyy HH:mm'
                            />
                        );
                    }}
                </Field>
                {errors.deliveryTime && touched.deliveryTime &&
                    <p className={styles.invalidMessage}>
                        {errors.deliveryTime}
                    </p>
                }
            </div>
            <div className={'mt-3'}>
                <h6>Warehouse Tujuan</h6>
                <Field name="warehouseId">
                    {({field, form: {setFieldValue}}) => {
                        return (
                            <Select 
                                {...field}
                                isClearable={true} required
                                placeholder={"Pilih warehouse tujuan pengiriman sampel"}
                                options={getWarehouseMapping()}
                                onChange={(e) => handleSelectWarehouse(e)}
                                value={getWarehouseMapping().find(({ value }) => value === values.warehouseId)}
                            />
                        );
                    }}
                </Field>
                {values.warehouseAddress &&
                    <p className={styles.fieldMessage}>
                        <span className={'fw-bolder'}>Alamat: </span>{values.warehouseAddress}
                    </p>
                }
                {errors.warehouseId && touched.warehouseId &&
                    <p className={styles.invalidMessage}>
                        {errors.warehouseId}
                    </p>
                }
            </div>
        </div>
        <div className={`${styles.sectionCard} mt-3`}>
            <div>
                <h5>Daftar Sampel</h5>
                <p>
                    Pastikan sampel yang dikirim ke warehouse Segari sesuai dengan daftar sampel
                    yang diisi di sini.
                </p>
            </div>
            <div>
                <FieldArray
                    name="sampleItems"
                    render={arrayHelpers => (
                        values.sampleItems && values.sampleItems.length > 0 &&
                        values.sampleItems.map((sample, index) =>
                            <InputSampleForm {...props} index={index} onDelete={showDeletionModal}/>
                        )
                    )}/>
                <InputSampleDeletionModal {...deletionModal} onHide={hideDeletionModal} onDelete={removeSample}/>
                {values.sampleItems.length < 10 ?
                    <Button type={'button'} className={'mt-5'} variant={'outline-success'}
                            style={{width: 200}} onClick={createSample}>
                        + Tambah Barang
                    </Button>
                :
                    <p className={styles.disabledMessage}>Hanya bisa maks. 10 barang</p>
                }
            </div>
        </div>
        <div className={'my-3'} style={{width: '90%'}}>
            <Button type={'button'} className={'float-end'} variant={"success"} onClick={props.forward}
                disabled={isDisabledNextButton()}>
                Simpan
            </Button>
        </div>
    </>
}

export default InputSampleSection;